<template>
  <div
    class="h-full min-h-[26rem] flex flex-col justify-between items-start gap-y-5 border border-brand-gray-300 rounded-lg py-4 px-6 shadow-md"
  >
    <div class="flex-1">
      <slot name="title"> </slot>
    </div>
    <div class="w-full flex gap-x-4 justify-center">
      <button
        :class="[selectedAnswer ? 'border-primary' : 'border-brand-gray-600']"
        class="rounded-md border p-4 flex flex-col items-center justify-center gap-y-4 aspect-square"
        @click="selectedAnswer = true"
      >
        <component
          :is="selectedAnswer ? faCircleCheck : faCircle"
          :class="[selectedAnswer ? 'fill-primary' : 'fill-brand-gray-600']"
          class="w-16"
        />
        <span :class="{ 'text-primary': selectedAnswer }">{{ $t('yes') }}</span>
      </button>
      <button
        :class="[!selectedAnswer ? 'border-primary' : 'border-brand-gray-600']"
        class="rounded-md border p-4 flex flex-col items-center justify-center gap-y-4 aspect-square"
        @click="selectedAnswer = false"
      >
        <component
          :is="!selectedAnswer ? faCircleCheck : faCircle"
          :class="[!selectedAnswer ? 'fill-primary' : 'fill-brand-gray-600']"
          class="w-16"
        />
        <span :class="{ 'text-primary': !selectedAnswer }">{{ $t('no') }}</span>
      </button>
    </div>
    <div class="w-full flex justify-between py-2">
      <FilledButton v-if="canGoBack" class="px-5 py-1.5 text-white" @click="$emit('onBack')">
        {{ $t('back') }}
      </FilledButton>
      <div v-else></div>
      <div class="flex gap-x-4">
        <FilledButton
          v-if="canCheck && selectedAnswer"
          class="px-5 py-1.5 text-white"
          @click="$emit('onCheck', selectedAnswer)"
        >
          {{ $t('check') }}
        </FilledButton>
        <FilledButton
          v-if="canGoNext"
          class="px-5 py-1.5 text-white"
          @click="$emit('onNext', selectedAnswer)"
        >
          {{ $t('next') }}
        </FilledButton>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import faCircle from '@/assets/icons/faCircle.svg'
import faCircleCheck from '@/assets/icons/faCircleCheck.svg'
import FilledButton from '@/components/Buttons/Filled.vue'

const props = defineProps({
  title: String,
  answer: Boolean,
  canGoBack: Boolean,
  canCheck: Boolean,
  canGoNext: Boolean
})

const selectedAnswer = ref(props.answer)
</script>

<style lang="scss" scoped></style>
